export default __webpack_public_path__ + "static/media/rust.d94f87fa.svg";